"use client";

import { QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { FC, PropsWithChildren } from "react";

import { useUIStore } from "stores/ui.store";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      gcTime: 1000 * 60 * 10,
    },
  },
  queryCache: new QueryCache({
    onError: (error, { meta }) =>
      (!meta?.withoutError as boolean) &&
      useUIStore
        .getState()
        .actions.toast.openToast({ variant: "error", message: (meta?.error as string) ?? error.message }),
  }),
});

const ReactQueryProvider: FC<PropsWithChildren> = ({ children }) => {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};

export { ReactQueryProvider };
